(function () {
/* eslint-disable no-plusplus */ /**
 * Carousel JavaScript
 *
 * This file defines behaviors of
 * the Carousel block.
 */ // for each grid item
var $06d6729e992d2a85$var$_document_querySelectorAll;
($06d6729e992d2a85$var$_document_querySelectorAll = document.querySelectorAll('.popup-grid__item')) === null || $06d6729e992d2a85$var$_document_querySelectorAll === void 0 ? void 0 : $06d6729e992d2a85$var$_document_querySelectorAll.forEach(function(item) {
    // if we have a popup
    var popup = item.querySelector('.popup');
    if (popup) {
        var // link existing buttons to this id
        _item_querySelectorAll;
        // create a unique id
        var id = "popup-grid-".concat(++window.aquamin.disambiguate);
        popup.setAttribute('id', id);
        (_item_querySelectorAll = item.querySelectorAll('a[href="#popup"')) === null || _item_querySelectorAll === void 0 ? void 0 : _item_querySelectorAll.forEach(function(button) {
            button.setAttribute('href', "#".concat(id));
        });
        // link media to this id
        var mediaWrap = item.firstElementChild;
        var media = mediaWrap.firstElementChild;
        var a = document.createElement('a');
        a.setAttribute('href', "#".concat(id));
        a.setAttribute('aria-label', mediaWrap.dataset.label);
        a.classList.add('popup-grid__media');
        a.append(media);
        item.firstElementChild.replaceWith(a);
    }
});

})();
//# sourceMappingURL=popup-grid-script.js.map
